import { render, staticRenderFns } from "./NewRegistration.vue?vue&type=template&id=33213566&scoped=true&"
import script from "./NewRegistration.vue?vue&type=script&lang=js&"
export * from "./NewRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33213566",
  null
  
)

export default component.exports